export const accessControlProfilesKeys = {
  all: ['access-control-profiles'],
  lists: () => [...accessControlProfilesKeys.all, 'list'],
  list: () => [...accessControlProfilesKeys.lists()],
} as const;
